/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlSecurityCopilotUserResponse
 */
export interface ControlSecurityCopilotUserResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlSecurityCopilotUserResponse
     */
    client_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSecurityCopilotUserResponse
     */
    org_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSecurityCopilotUserResponse
     */
    crole_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSecurityCopilotUserResponse
     */
    entity_id: string;
}

/**
 * Check if a given object implements the ControlSecurityCopilotUserResponse interface.
 */
export function instanceOfControlSecurityCopilotUserResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "client_id" in value;
    isInstance = isInstance && "crole_id" in value;
    isInstance = isInstance && "entity_id" in value;

    return isInstance;
}

export function ControlSecurityCopilotUserResponseFromJSON(json: any): ControlSecurityCopilotUserResponse {
    return ControlSecurityCopilotUserResponseFromJSONTyped(json, false);
}

export function ControlSecurityCopilotUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSecurityCopilotUserResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'client_id': json['client_id'],
        'org_id': !exists(json, 'org_id') ? undefined : json['org_id'],
        'crole_id': json['crole_id'],
        'entity_id': json['entity_id'],
    };
}

export function ControlSecurityCopilotUserResponseToJSON(value?: ControlSecurityCopilotUserResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'client_id': value.client_id,
        'org_id': value.org_id,
        'crole_id': value.crole_id,
        'entity_id': value.entity_id,
    };
}

